<template>
  <div id="salesmanList" >
    <!-- 查询选项 -->
    <el-form id="suffixId" class="salesmanForm" :model="searchForm" ref="searchForm" :rules="rules" label-width="150px">
      <el-form-item class="form_item" :label="$t('country1')" prop="country">
        <el-select filterable v-model="searchForm.country" clearable :placeholder="$t('select')">
          <el-option v-for="item in LocationList" :key="item.sysValue" :label="item.sysValue" :value="item.sysValue"></el-option>
        </el-select>
      </el-form-item>
      <div class="buttonDiv">
        <el-button type="primary" size="mini" icon="el-icon-search" @click="submitForm('searchForm')">{{$t('search')}}</el-button>
        <el-button type="primary" size="mini" icon="el-icon-upload" @click="importExcel">{{$t('import')}}</el-button>
      </div>
    </el-form>
    <div class="contentTableDiv">
      <!-- <el-table :data="tableData" border style="width: 100%" tooltip-effect="dark" :header-cell-style="{background:'#F5F5F9'}" >
        <el-table-column prop="holidayCountry" :label="$t('country')" align="center" ></el-table-column>
        <el-table-column prop="holidayDate" :label="$t('holidayDate')" align="center" ></el-table-column>
        <el-table-column prop="isHoliday" :label="$t('isHoliday')" align="center" ></el-table-column>
        <el-table-column prop="remark" :label="$t('remark')" align="center" ></el-table-column>
        <el-table-column prop="createDate" :label="$t('createTime')" align="center"></el-table-column>
      </el-table> -->
      <!-- <el-calendar v-model="value"></el-calendar> -->
      <el-calendar v-model="value">
        <template slot="dateCell" slot-scope="{date, data}">
          <div>{{data.day.split('-').slice(2).join()}}</div>
          <div style="margin-top: 10px;">
            <p style="color: tomato;" v-if="handleSelected(data.day) == 'No'">{{'work'}}</p>
            <p style="color: forestgreen;" v-if="handleSelected(data.day) == 'Yes'">{{'holiday'}}</p>
          </div>
        </template>
      </el-calendar>
    </div>
    
    <!-- <div class="pageDiv">
      <el-pagination small @size-change="changePageSize" @current-change="changePage" :current-page="currentPage" :page-sizes="[10,20,50,100]"
         :page-size="pageSize" layout="total, prev, pager, next, sizes, jumper" :total="totalCount">
      </el-pagination>
    </div> -->

    <Modal v-model="modelImport" :closable='true' :mask-closable='true' width="60%" title="Holiday">
      <div slot="footer"></div>
      <el-table :data="gridData" border style="width: 100%;" >
        <el-table-column label="Template Download" align="center">
          <template><el-button size="mini" type="primary" @click="downloadTemplate">{{'HolidayTemplate'}}</el-button></template>
        </el-table-column>
        <el-table-column label="File Location" align="center">
          <el-upload ref="uploadFile" action="" :accept="acceptFileType" :limit="1" :on-exceed="handleExceed" :before-upload="beforeUpload" 
            :file-list="fileList" :auto-upload="false">   
            <el-button size="mini" type="primary">{{'Select File'}}</el-button>              
          </el-upload>
        </el-table-column>
        <el-table-column align="center">
          <el-button type="primary" size="mini" @click="submitUpload">{{'Confirm Import'}}</el-button>
        </el-table-column>
      </el-table>
    </Modal>
  </div>
</template>
<script>
    import * as validate from '@/utils/validate'

    export default {
        name: 'holiday',
        created () {
           this.getLocation();
        },
        data () {
            return {
              value: new Date(),
              searchForm:{
                country:null,
              },
              LocationList:[],
              tableData: [],
              gridData:[{}],
              fileList:[],
              acceptFileType:'.xls,.xlsx',
              modelImport:false,
              currentPage: 1,
              totalCount: 0,
              pageSize: 10,
              rules: {
                country: [
                  { required: true, message: 'Please select country', trigger: 'change'},
                ],
              },
            }
        },
        methods: {
          getLocation(){
            let url =`${this.$store.state.islhurl}keyValue/getLocation`;
            let pm = {
              sysKey: 'Country',
              delFlg: '0',
            }
            this._post(url,pm).then(
              res => {   
                this.LocationList = res.data;
              }
            )
          },
          getHolidayInfo(){
            let url = `${this.$store.state.islhurl}getHolidayInfo/${this.pageSize}/${this.currentPage}`
            let pm = {
              country: this.searchForm.country==''?null:this.searchForm.country,
              islhToken : sessionStorage.getItem('islhtoken'),
            }
            this._post(url,pm).then(
              res =>{
                this.tableData = res.data;
                this.totalCount = res.totalNums;
              }
            )
          },
          handleSelected(day) {
            let holidayInfo = this.tableData.find(item => {
              return item.holidayDate === day;
            })
            let isHoliday = 0;
            if(holidayInfo != null){
              isHoliday = holidayInfo.isHoliday;
            }
            return isHoliday;
          },
          submitForm(formName){
            this.$refs[formName].validate((valid) => {
              if (valid) {
                this.searchHolidayInfo();
              } else {
                return false;
              }
            });
          },
          searchHolidayInfo(){
            let url = `${this.$store.state.islhurl}holiday/getInfo`
            let pm = {
              holidayCountry: this.searchForm.country==''?null:this.searchForm.country,
              islhToken : sessionStorage.getItem('islhtoken'),
            }
            this._post(url,pm).then(
              res =>{
                this.tableData = res.holidays;
              }
            )
          },
          importExcel(){
            this.fileList = [];
            this.modelImport = true;
          },
          handleExceed(files,fileList){
            this.$message.warning('Please delete the uploaded file first!');
          },
          downloadTemplate(){
            window.location.href = `${this.$store.state.islhurl}`+"template?fileName=HolidayTemplate.xlsx";
          },
          submitUpload(){
            if(this.$refs.uploadFile.$children[0].fileList.length == 1){
                this.$refs.uploadFile.submit();
            }else{
              this.$message({
                type:'error',
                showClose:true,
                duration:5000,
                message:'Please select file first!'
              });
            };
          },
          beforeUpload(file){
            var fileName = file.name.substring(file.name.lastIndexOf('.')+1);
            if(fileName != 'xls' && fileName != 'xlsx'){
              this.$message({
                type:'error',
                showClose:true,
                duration:5000,
                message:'Please select .xls or .xlsx file!'
              });
              return false;
            }
            this.downloadLoading = this.$loading({
              lock:true,
              text:'Data is importing...',
              spinner:'el-icon-loading',
              background:'rgba(0,0,0,0.7)'
            });
            this.modelImport = false;
            let fd = new FormData();
            fd.append('file',file);
            fd.append('islhToken',sessionStorage.getItem("islhtoken"));
            let url = `${this.$store.state.islhurl}holiday/importInfo`
            this._post(url,fd).then(
              res =>{
                this.downloadLoading.close();
                if(res=="200"){
                  this.$message.success('Operation Complete！');
                }else{
                  this.$message({
                    type:'error',
                    showClose:true,
                    duration:10000,
                    dangerouslyUseHTMLString: true,
                    message:res
                  });
                }
              }
            )
          },
          // 分页
          changePage (val) {
            this.currentPage = val;
            this.getHolidayInfo();
          },
          // 改变当前页显示条数
          changePageSize (val) {
            this.pageSize = val;
            this.getHolidayInfo();
          }
        }
    }
</script>



// WEBPACK FOOTER //
// src/view/base/holiday.vue